var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIcnChevronDown = function SvgIcnChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.646 3.646 1.5.5a.707.707 0 0 0-1 1l3.793 3.793a1 1 0 0 0 1.414 0L9.5 1.5a.707.707 0 0 0-1-1L5.354 3.646a.5.5 0 0 1-.708 0Z",
    fill: "#fff"
  })));
};

export { SvgIcnChevronDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik00LjY0NjQ1IDMuNjQ2NDVMMS41IDAuNUMxLjIyMzg2IDAuMjIzODU4IDAuNzc2MTQyIDAuMjIzODU4IDAuNSAwLjVDMC4yMjM4NTggMC43NzYxNDIgMC4yMjM4NTcgMS4yMjM4NiAwLjUgMS41TDQuMjkyODkgNS4yOTI4OUM0LjY4MzQyIDUuNjgzNDIgNS4zMTY1OCA1LjY4MzQyIDUuNzA3MTEgNS4yOTI4OUw5LjUgMS41QzkuNzc2MTQgMS4yMjM4NiA5Ljc3NjE0IDAuNzc2MTQyIDkuNSAwLjVDOS4yMjM4NiAwLjIyMzg1OCA4Ljc3NjE0IDAuMjIzODU3IDguNSAwLjVMNS4zNTM1NSAzLjY0NjQ1QzUuMTU4MjkgMy44NDE3MSA0Ljg0MTcxIDMuODQxNzEgNC42NDY0NSAzLjY0NjQ1WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";